"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHInputKeyOr = void 0;
const KHInputKeyDerived_1 = require("./KHInputKeyDerived");
/**
 * An input key that requires any of the keys its listening on to be true to
 * trigger.
 */
class KHInputKeyOr extends KHInputKeyDerived_1.KHInputKeyDerived {
    /**
     *
     * @param inputSet Input set
     * @param sources Keys to listen on
     * @param retriggerOnEveryJustDown Whether or not any input source emitting justDown should make this input emit it as well.
     */
    constructor(inputSet, sources, retriggerOnEveryJustDown = false) {
        super(inputSet);
        this.sources = sources;
        this.retriggerOnEveryJustDown = retriggerOnEveryJustDown;
        // Clear out just down if not applicable.
        this.setInitalState();
    }
    setInitalState() {
        let jd = false;
        let down = false;
        for (let i = 0; i < this.sources.length; i++) {
            if (this.sources[i].isDown()) {
                down = true;
            }
            if (this.sources[i].isJustDown()) {
                jd = true;
            }
        }
        this.down = down;
        this.justDown = jd;
    }
    updateDerivedInput() {
        let anyDown = false;
        let anyJustDown = false;
        if (this.retriggerOnEveryJustDown) {
            for (let i = 0; i < this.sources.length; i++) {
                if (this.sources[i].isDown()) {
                    anyDown = true;
                }
                if (this.sources[i].isJustDown()) {
                    anyJustDown = true;
                }
            }
            super.updateInternal(anyDown, anyJustDown);
        }
        else {
            for (let i = 0; i < this.sources.length; i++) {
                if (this.sources[i].isDown()) {
                    anyDown = true;
                    break;
                }
            }
            super.update(anyDown);
        }
    }
}
exports.KHInputKeyOr = KHInputKeyOr;
